<template>
  <div>
    <b-modal
      ref="modal-tag-add"
      size="lg"
      scrollable
      centered
      :hide-footer="true"
      @hide="hideModal"
    >
      <template #modal-title>
        <i :class="data.id ? 'icon-note' : 'fa fa-plus'"></i> {{ data.id ? 'Editar Tag' : 'Adicionar Tag' }}
      </template>

      <Forms
        ref="frmDefault"
        :title="''"
        :showClearButton="!data.id"
        :showSaveButton="true"
        :showBackButton="true"
        :showTipFooter="false"
        v-on:Clear="onClear"
        v-on:Save="onSave"
        v-on:Back="hideModal"
      >
        <div class="form-group row">
          <div class="col-md-12">
            <label><small v-show="form.nome.required" class="text-danger">*</small> Nome:</label>
            <div class="input-group">
              <b-form-input type="text"
                            placeholder="Digite o nome da tag"
                            v-model="form.nome.value"
                            :maxlength="form.nome.maxlength"
                            :required="form.nome.required"
                            :state="form.nome.state"
                            :formatter="value => value.toUpperCase()"
                            @input="form.nome.state = null"></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <label><small v-show="form.abreviacao.required" class="text-danger">*</small> Abreviação:</label>
            <div class="input-group">
              <b-form-input type="text"
                            placeholder="Digite a abreviação"
                            v-model="form.abreviacao.value"
                            :maxlength="form.abreviacao.maxlength"
                            :required="form.abreviacao.required"
                            :state="form.abreviacao.state"
                            :formatter="value => value.toUpperCase()"
                            @input="form.abreviacao.state = null"></b-form-input>
            </div>
            <small class="form-text text-muted">Máx. {{ form.abreviacao.maxlength }} letras - {{ (form.abreviacao.value || '').length }}/{{ form.abreviacao.maxlength }} caracteres</small>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <label><small v-show="form.cor.required" class="text-danger">*</small> Cor:</label>
            <div class="input-group">
              <b-form-input type="text"
                            placeholder="#3B82F6"
                            v-model="form.cor.value"
                            :maxlength="form.cor.maxlength"
                            :required="form.cor.required"
                            :state="form.cor.state"
                            readonly></b-form-input>
              <div class="input-group-append">
                <b-form-input type="color"
                              v-model="form.cor.value"
                              class="color-picker-input"
                              :state="form.cor.state"
                              @input="form.cor.state = null"></b-form-input>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <label><small v-show="form.corTexto.required" class="text-danger">*</small> Cor do Texto:</label>
            <div class="input-group">
              <b-form-input type="text"
                            placeholder="#FFFFFF"
                            v-model="form.corTexto.value"
                            :maxlength="form.corTexto.maxlength"
                            :required="form.corTexto.required"
                            :state="form.corTexto.state"
                            readonly></b-form-input>
              <div class="input-group-append">
                <b-form-input type="color"
                              v-model="form.corTexto.value"
                              class="color-picker-input"
                              :state="form.corTexto.state"
                              @input="form.corTexto.state = null"></b-form-input>
              </div>
            </div>
          </div>
        </div>
      </Forms>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import Forms from '@/components/forms/Forms.vue'

import TagModel from '@/shared/models/configurations/tagmodel.js'
import TagForms from './tag-form.js'
import TagRepository from '@/shared/http/repositories/configurations/tag.js'

export default {
  name: 'TagAddModal',
  mixins: [ActionsForm],
  components: {
    Forms
  },
  data () {
    return {
      data: TagModel,
      form: TagForms
    }
  },
  watch: {
    'form.cor.value' () {
      if (this.form.cor.value) {
        this.form.cor.state = null
      }
    },
    'form.corTexto.value' () {
      if (this.form.corTexto.value) {
        this.form.corTexto.state = null
      }
    }
  },
  methods: {
    showModal (obj = null) {
      if (obj) {
        this.onEdit(obj)
      } else {
        this.onClear()
      }
      this.$refs['modal-tag-add'].show()
    },
    hideModal () {
      this.$refs['modal-tag-add'].hide()
      // Limpa os dados após fechar o modal
      this.$nextTick(() => {
        this.onClear()
        this.data.id = null
      })
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      // Se corTexto vier null do banco, preenche com valor padrão
      if (!this.form.corTexto.value || this.form.corTexto.value === null) {
        this.form.corTexto.value = '#FFFFFF'
      }
      // Se cor vier null do banco, preenche com valor padrão
      if (!this.form.cor.value || this.form.cor.value === null) {
        this.form.cor.value = '#3B82F6'
      }
      loading.pop()
    },
    onSave () {
      let hasError = false

      // Valida todos os campos obrigatórios e marca os inválidos
      if (!this.form.nome.value || this.form.nome.value.trim() === '') {
        this.$set(this.form.nome, 'state', false)
        hasError = true
      } else {
        this.$set(this.form.nome, 'state', null)
      }

      if (!this.form.abreviacao.value || this.form.abreviacao.value.trim() === '') {
        this.$set(this.form.abreviacao, 'state', false)
        hasError = true
      } else {
        this.$set(this.form.abreviacao, 'state', null)
      }

      if (!this.form.cor.value || this.form.cor.value.trim() === '') {
        this.$set(this.form.cor, 'state', false)
        hasError = true
      } else {
        this.$set(this.form.cor, 'state', null)
      }

      if (!this.form.corTexto.value || this.form.corTexto.value.trim() === '') {
        this.$set(this.form.corTexto, 'state', false)
        hasError = true
      } else {
        this.$set(this.form.corTexto, 'state', null)
      }

      if (hasError) {
        toast.warning(this.$lang.Common.Alerts.RequiredField)
        return
      }

      // Se passou na validação, salva os valores
      Tools.SetValueToSave(this.form, this.data)

      // Garante que os valores sejam copiados corretamente do form para data
      this.data.nome = this.form.nome.value ? this.form.nome.value.trim() : null
      this.data.abreviacao = this.form.abreviacao.value ? this.form.abreviacao.value.trim() : null
      this.data.cor = this.form.cor.value || '#3B82F6'
      this.data.corTexto = this.form.corTexto.value || '#FFFFFF'

      // Garante que corTexto sempre tenha um valor (não pode ser null ou vazio)
      if (!this.data.corTexto || this.data.corTexto.trim() === '') {
        this.data.corTexto = '#FFFFFF'
      }
      // Garante que cor sempre tenha um valor (não pode ser null ou vazio)
      if (!this.data.cor || this.data.cor.trim() === '') {
        this.data.cor = '#3B82F6'
      }

      if (this.data.id) {
        this.onUpdate()
      } else {
        this.onCreate()
      }
    },
    onCreate () {
      loading.push()
      TagRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.hideModal()
          toast.success(this.$lang.Common.Alerts.Success)
          this.$emit('created')
        })
        .catch((err) => {
          loading.close()
          // Verifica se há mensagem específica do backend (erro de validação)
          if (err && err.data && err.data.errors &&
              Array.isArray(err.data.errors) && err.data.errors.length > 0) {
            const errorMessage = err.data.errors[0].message
            if (errorMessage) {
              // Exibe em amarelo (warning) igual aos campos não preenchidos
              toast.warning(errorMessage, 'Atenção')
              return // Importante: retorna para não chamar onException
            }
          }
          // Se não encontrou mensagem específica, usa o tratamento padrão
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)

      // Garante que corTexto sempre tenha um valor antes de enviar
      if (!this.data.corTexto || this.data.corTexto.trim() === '') {
        this.data.corTexto = '#FFFFFF'
      }
      // Garante que cor sempre tenha um valor antes de enviar
      if (!this.data.cor || this.data.cor.trim() === '') {
        this.data.cor = '#3B82F6'
      }

      TagRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.hideModal()
          toast.success(this.$lang.Common.Alerts.Success)
          this.$emit('created')
        })
        .catch((err) => {
          loading.close()
          // Verifica se há mensagem específica do backend (erro de validação)
          if (err && err.data && err.data.errors &&
              Array.isArray(err.data.errors) && err.data.errors.length > 0) {
            const errorMessage = err.data.errors[0].message
            if (errorMessage) {
              // Exibe em amarelo (warning) igual aos campos não preenchidos
              toast.warning(errorMessage, 'Atenção')
              return // Importante: retorna para não chamar onException
            }
          }
          // Se não encontrou mensagem específica, usa o tratamento padrão
          this.onException(err)
        })
    }
  }
}
</script>

<style scoped>
.color-picker-input {
  width: 50px !important;
  height: 38px !important;
  border: 1px solid #ced4da !important;
  border-left: none !important;
  cursor: pointer;
  padding: 0 !important;
}

.color-picker-input:focus {
  border-color: #80bdff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

.input-group .form-control[readonly] {
  background-color: #e9ecef;
  cursor: not-allowed;
}

/* Garantir que campos inválidos fiquem vermelhos */
.form-control.is-invalid,
.custom-select.is-invalid,
.was-validated .form-control:invalid,
input.is-invalid {
  border-color: #dc3545 !important;
}

.form-control.is-invalid:focus,
.custom-select.is-invalid:focus,
.was-validated .form-control:invalid:focus,
input.is-invalid:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

/* Para inputs dentro de input-group */
.input-group .form-control.is-invalid {
  border-color: #dc3545 !important;
  z-index: 3;
}

.input-group .form-control.is-invalid:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/board/tag/components/add/TagAddModal.vue